var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", "max-width": "750px" } },
    [
      _c(
        "v-card",
        { attrs: { width: "1000" } },
        [
          _c("v-card-title", [
            _c("span", [_vm._v("Confirm Linked Group Update")]),
          ]),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              height: 500,
              loading: _vm.loading,
              "items-per-page": -1,
              "show-select": "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.new_multiplier",
                fn: function () {
                  return [
                    _c("td", { staticClass: "noWrap" }, [
                      _vm._v(_vm._s(_vm.newMultiplier)),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "item.new_srp",
                fn: function () {
                  return [
                    _c("td", { staticClass: "noWrap" }, [
                      _vm._v("$" + _vm._s(_vm._f("format")(_vm.newSrp))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedItems,
              callback: function ($$v) {
                _vm.selectedItems = $$v
              },
              expression: "selectedItems",
            },
          }),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { attrs: { flat: "" } },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.closeModal } },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "blue white--text mr-2",
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.updateItems },
                },
                [_vm._v(" Save Selected Items ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }